import React, { Component } from 'react'
import Style from './style.module.less'
import Tabs from './tabs'
import Store from './store'
import { observer, Provider } from 'mobx-react'
import { RouterView } from '@merchant-backend/common-components'
import PageHeader from '@common/PageHeader'

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    const {
      location: {
        query: { key }
      }
    } = this.props

    this.store = new Store(key)
    this.store.isEditVerticalImage()
    this.store.getUnAuditNumber()
  }

  render() {
    const { shouldEditVerticalImg } = this.store
    return (
      <Provider store={this.store}>
        <>
          <RouterView
            className={Style.sitebox}
            renderHeader={() =>
              shouldEditVerticalImg ? (
                <PageHeader title="因用户端首页feeds样式调整，只有上传了竖图，宴会厅才会在首页曝光哦，快去设置竖图吧～" />
              ) : null
            }
          >
            <Tabs />
          </RouterView>
        </>
      </Provider>
    )
  }
}
